import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders, HttpParams } from '@angular/common/http';
import { url } from 'src/app/config/config';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})

export class DocumentosService {

    public url=url;

    constructor(private http:HttpClient){

    }

    recogerZip(role:string){
        let headers=new HttpHeaders();
    
   
    headers.append('Content-Type' , 'application/json');
       
        let body=JSON.stringify({"role":role});
       return this.http.post(this.url+"backup/exporttocsv.php",body,{headers:headers}).pipe(map(resp=>{
            return resp;
        }));
      /*   return this.http.get(this.url+"backup/exporttocsv.php").pipe(map(resp=>{
            return resp;
        })); */
    }
}